import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Select,
  Tooltip,
} from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import {
  IconClock,
  IconPlus,
  IconSearch,
  IconWritingSign,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getColorByType,
  openModelHistory,
  pageTable,
  repositorySign,
  signTypes,
  styleTable,
} from "../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { _localization } from "../../config/location";
import { getProcessDefSelect, getUsersSelect } from "../../const/getSelectApi";
import { ListAccessSignSearchModel } from "../../model/BaseSearchModel";
import { DocumentStepInfoModel } from "../../model/DocumentStepInfoModel";
import { MessageResponse } from "../../model/MessageResponse";
import "./tab.component.css";

const ListAccessSign = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<DocumentStepInfoModel[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [dataFetch, setDataFetch] = useState<SelectListItem[]>([]);
  const [listVendor, setListVendor] = useState<SelectListItem[]>([]);
  const [listDocType, setListDocType] = useState<SelectListItem[]>([]);
  const [listEmployee, setListEmployee] = useState<SelectListItem[]>([]);
  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [dateProcessDef, setProcessDef] = useState<SelectListItem[]>([]);
  const [processDefId, setprocessDefId] = useState<number>(0);
  const [dateUsers, setUsers] = useState<SelectListItem[]>([]);

  const navigate = useNavigate();
  const search: ListAccessSignSearchModel = {
    skip: 0,
    take: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      //
      let issS = sorting && sorting.length;
      // url.searchParams.set("soft", `${_softing}`);
      //
      const queryParams: ListAccessSignSearchModel = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
        keySearch: form.getValues().keySearch,
        fromDate: form.getValues().fromDate,
        toDate: form.getValues().toDate,
        createBy: form.getValues().createBy,
        sort: issS ? sorting[0].id : "",
        isOrder: issS ? sorting[0].desc : false,
        documentTemplate: processDefId > 0 ? processDefId : 0,
      };

      const baseUrl = "/api/v1/SignPage/list-access-sign";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue =
              value instanceof Date ? value.toISOString() : value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
      const response = await repositorySign.get<
        MessageResponse<DocumentStepInfoModel[]>
      >(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        // await dataOrderTypeSelect();
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  useEffect(() => {
    getUser();
    getProcessDef();
  }, []);

  const VIEWED_ROWS_KEY = "folders_viewed_rows_approve_task";
  function getViewedRows(): number[] {
    try {
      const data = localStorage.getItem(VIEWED_ROWS_KEY);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }

  function setViewedRows(ids: number[]) {
    localStorage.setItem(VIEWED_ROWS_KEY, JSON.stringify(ids));
  }

  const [viewedRows, setViewedRowsState] = useState<number[]>(getViewedRows());

  const handleRowClick = (row: any) => {
    const id = row.original.codeDocument;
    if (!id) return;
    let newViewed: number[] = viewedRows.includes(id) ? [] : [id];
    setViewedRowsState(newViewed);
    setViewedRows(newViewed);
  };

  const getRowStyle = (row: any) => {
    if (viewedRows.includes(row.original.codeDocument)) {
      return {
        ...styleTable,
        backgroundColor: "#ffc04c",
        transition: "background-color 0.2s",
      };
    }
    return styleTable;
  };

  async function getUser() {
    const data = await getUsersSelect();
    if (data && data.length > 0) setUsers(data);
  }

  async function getProcessDef() {
    const data = await getProcessDefSelect();
    if (data && data.length > 0) setProcessDef(data);
  }
  function getColorStatus(text: string) {
    switch (text.trim()) {
      case "Đang duyệt":
        return "blue";
      case "Đã duyệt":
        return "teal";
      case "Từ chối":
        return "red";
      //  case "Hủy duyệt":
      default:
        return "orange";
    }
  }

  const columns = React.useMemo<MRT_ColumnDef<DocumentStepInfoModel>[]>(
    () => [
      {
        accessorKey: "codeDocument",
        header: "Mã hồ sơ",
        enableGlobalFilter: true,
        //  size: 30,
        Cell: ({ renderedCellValue, row }) => {
          return (
            <Badge
              radius="sm"
              variant="dot"
              tt="capitalize"
              color="green"
              fw={700}
            >
              {renderedCellValue}
            </Badge>
          );
        },
      },
      {
        accessorKey: "nameDocument",
        header: "Tên hồ sơ",
      },
      {
        accessorKey: "nameStep",
        header: "Tên công việc",
      },
      {
        accessorKey: "typesigncustomer",
        header: "Loại ký",
        Cell: ({ renderedCellValue }: any) => {
          const type = signTypes.find((x) => x.value === renderedCellValue);
          const color = type ? getColorByType(type.value) : "gray";

          return <Badge color={color}>{type?.label || "Unknown"}</Badge>;
        },
      },
      {
        accessorKey: "signDateBefore",
        header: "Thời gian ký trước",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "startDate",
        header: "Hiệu lực từ",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "endDate",
        header: "Hiệu lực đến",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "expirationDate",
        header: "Ngày hết hạn ký",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },

      {
        accessorKey: "action",
        header: "Thao tác",
        size: 50,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip
              label={"Ký"}
              onClick={() => {
                const _id = Number.parseInt(row.id);
                if (_id < 1)
                  NotificationExtension.Fails("Mã hồ sơ không hợp lệ !");
                else navigate(`/method/sign-page/${_id}`);
              }}
            >
              <ActionIcon color="violet" variant="light" aria-label="Settings">
                <IconWritingSign size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label={"Lịch sử"}>
              <ActionIcon
                onClick={() => {
                  if (row.original.documentId && row.original.documentId > 0)
                    openModelHistory(row.original.documentId);
                  else NotificationExtension.Info("Hồ sơ chưa trình ký!");
                }}
                color="indigo"
                variant="light"
                aria-label="Settings"
              >
                <IconClock size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            {/* <Tooltip label={"Sửa"}>
              <ActionIcon color="yellow" variant="light" aria-label="Settings">
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip> */}
          </Box>
        ),
      },
    ],
    [listVendor, dataFetch, listEmployee, listDocType]
  );

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable<DocumentStepInfoModel>({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    localization: _localization,
    enableRowSelection: true,
    enableTopToolbar: false,
    getRowId: (row) => row?.listStepId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTable,
    }),
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: () => handleRowClick(row),
      style: getRowStyle(row),
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });
  const _span = { base: 4, md: 3, lg: 2 };
  const [dataEmp, setDataEmp] = useState<SelectListItem[]>([]);
  const fetchDataEmployee = async () => {
    const dataApi = await getUsersSelect();
    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item: any) => item.text !== null);
      setDataEmp(filteredData);
    }
  };
  //#endregion
  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Button
            leftSection={<IconPlus size={14} />}
            color="green"
            variant="outline"
            onClick={() => {
              NotificationExtension.Info(
                "Chức năng này đang được phát triển !"
              );
            }}
          >
            Ký theo lô
          </Button>
        </Flex>
        <form>
          <Grid>
            <Grid.Col span={_span}>
              {" "}
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />{" "}
              </Input.Wrapper>
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                valueFormat="DD/MM/YYYY"
                label="Từ ngày"
                clearable
                placeholder="Chọn từ ngày ..."
                key={form.key(`fromDate`)}
                {...form.getInputProps("fromDate")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                valueFormat="DD/MM/YYYY"
                label="Đến ngày"
                clearable
                placeholder="Chọn đến ngày ..."
                key={form.key(`toDate`)}
                {...form.getInputProps("toDate")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                id="flowModel"
                label="Quy trình mẫu"
                placeholder="Chọn"
                data={dateProcessDef?.map((item: SelectListItem) => {
                  return {
                    value: item.value,
                    label: item.text,
                  };
                })}
                value={processDefId.toString()}
                onChange={(e) => {
                  const value = parseFloat(e ?? ""); // Convert giá trị nhập thành số
                  if (!isNaN(value) && e) {
                    setprocessDefId(parseFloat(e));
                  } else {
                    setprocessDefId(0);
                  }
                }}
                nothingFoundMessage="Không có dữ liệu"
                searchable
                clearable
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Người tạo"
                placeholder="Chọn..."
                defaultValue="React"
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                data={dataEmp.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                onClick={async () => {
                  if (!dataEmp || dataEmp.length < 1) {
                    await fetchDataEmployee();
                  }
                  return;
                }}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`createBy`)}
                {...form.getInputProps("createBy")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              {" "}
              <Button
                mt={"25px"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async (e) => {
                  console.log(form.getValues());
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default ListAccessSign;
